import React, { useEffect, useState } from "react";
import FiltersPagination from "../../components/elements/FiltersPagination";
import DataTableElement from "../../components/elements/DataTableElement";
import { trailerTrucksResource } from "../../helpers/configRoutes/backend_helper";
import { ColumnsTrailer } from "./Columns";
import CustomButton from "../../components/form/CustomButton";
import { useNavigate } from "react-router-dom";
import AddUpdTrailerTruckModal from "./AddUpdTrailerTruck";
import ConfirmDeleteModal from "../../components/modal/ConfirmDeleteModal";

const Trailers = () => {
    const navigate = useNavigate();
    const [filters, setFilters] = useState({
        endDate: "",
        startDate: "",
        search: "",
        from: 0,
        to: 0,
        page: 1,
        truck: "",
    });
    const [tableLoad, setTableLoad] = useState({
        show: false,
        textLoad: "Loading trailers...",
    });
    const [meta, setMeta] = useState({ total: 0, current_page: 0 });
    const [data, setData] = useState([]);
    const [modalConfirm, setModalConfirm] = useState({
        show: false,
        title: "Delete Trailer",
        loadig: false,
        textLoad: "Processing",
    });
    const [modal, setModal] = useState({ show: false });
    const [trailerTruckItem, setTrailerTruckItem] = useState({ id: null });

    useEffect(() => {
        const getData = async () => {
            setTableLoad((prev) => ({ ...prev, show: true }));
            const response = await trailerTrucksResource("get", {
                params: filters,
            });
            setData(response.items);
            setMeta(response.meta);
            setTableLoad((prev) => ({ ...prev, show: false }));
        };
        getData();
    }, [filters]);

    const openModalAdd = (item = {}) => {
        setTrailerTruckItem(item);
        setModal({
            ...modal,
            show: true,
            truck: false,
        });
    };

    const deleteTrailerTruck = async () => {
        setModalConfirm((prev) => ({ ...prev, loading: true }));
        const response = await trailerTrucksResource("del", {}, modalConfirm.id);
        if (response.status) {
            setFilters({ ...filters });
        }
        setModalConfirm({
            ...modalConfirm,
            loading: false,
            show: false,
            id: null,
        });
    };

    const cols = ColumnsTrailer(openModalAdd, setModalConfirm, modalConfirm);

    return (
        <div className="min-h-screen bg-cs-bg-alt py-8 px-4">
            <div className="max-w-auto mx-auto">
                {/* Header */}
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 mb-4">
                    <div>
                        <p className="text-[10px] uppercase tracking-[0.18em] text-cs-muted">
                            Fleet center
                        </p>
                        <h1 className="text-2xl font-semibold text-cs-dark">
                            Trailers
                        </h1>
                        <p className="text-sm text-cs-muted mt-1">
                            Manage your trailers: type, specs, status and pairing with power units.
                        </p>
                    </div>
                    <div className="flex gap-2 justify-end">
                        <CustomButton
                            onClick={() => navigate("/trucks")}
                            className="
                                px-3 py-2 rounded-xl
                                bg-cs-bg
                                text-[10px] text-cs-muted
                                border border-cs-border
                                hover:bg-cs-primary-soft hover:text-cs-primary
                                transition-all
                            "
                        >
                            View trucks
                        </CustomButton>
                        <CustomButton
                            onClick={() => openModalAdd()}
                            className="
                                px-4 py-2 rounded-xl
                                bg-cs-primary
                                hover:bg-cs-primary-hover
                                text-white
                                text-[10px] font-medium
                                shadow-sm hover:shadow-md
                                inline-flex items-center gap-1
                            "
                        >
                            <span className="material-symbols-outlined text-[16px]">
                                add
                            </span>
                            Add new trailer
                        </CustomButton>
                    </div>
                </div>

                {/* Table + filters */}
                <FiltersPagination
                    showFilters={true}
                    filters={filters}
                    setFilters={setFilters}
                    meta={meta}
                    statusModel={"TrailerTruck"}
                >
                    <div className="bg-cs-bg border border-cs-border rounded-2xl shadow-sm">
                        <DataTableElement
                            columns={cols}
                            items={data}
                            tableLoad={tableLoad}
                        />
                    </div>
                </FiltersPagination>

                <AddUpdTrailerTruckModal
                    modal={modal}
                    setModal={setModal}
                    trailerTruckItem={trailerTruckItem}
                    setFilters={setFilters}
                    filters={filters}
                />
                <ConfirmDeleteModal
                    modal={modalConfirm}
                    setModal={setModalConfirm}
                    action={deleteTrailerTruck}
                />
            </div>
        </div>
    );
};

export default Trailers;
